var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 11.35c0-4.997 0-7.495 1.552-9.048C3.855.75 6.353.75 11.35.75h5.3c4.997 0 7.495 0 9.048 1.552 1.552 1.553 1.552 4.051 1.552 9.048v5.3c0 4.997 0 7.495-1.552 9.048-1.553 1.552-4.051 1.552-9.048 1.552h-5.3c-4.997 0-7.495 0-9.048-1.552C.75 24.145.75 21.647.75 16.65v-5.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 11.35c0-4.997 0-7.495 1.552-9.048C3.855.75 6.353.75 11.35.75h5.3c4.997 0 7.495 0 9.048 1.552 1.552 1.553 1.552 4.051 1.552 9.048v5.3c0 4.997 0 7.495-1.552 9.048-1.553 1.552-4.051 1.552-9.048 1.552h-5.3c-4.997 0-7.495 0-9.048-1.552C.75 24.145.75 21.647.75 16.65v-5.3z",
    fill: "#FA3D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.825 13.024V9.45h-1.943c-.645 0-1.15.157-1.514.473-.359.31-.538.747-.538 1.31 0 .568.18 1.01.538 1.325.36.31.864.466 1.514.466h1.944zm-1.673 1.499-2.643 3.865H9.4l2.853-4.127c-.709-.204-1.276-.575-1.703-1.114-.427-.538-.64-1.179-.64-1.921 0-.995.334-1.8 1.004-2.417.67-.616 1.552-.924 2.649-.924h4.127v10.503h-1.864v-3.865h-1.673z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 11.35c0-4.997 0-7.495 1.552-9.048C3.855.75 6.353.75 11.35.75h5.3c4.997 0 7.495 0 9.048 1.552 1.552 1.553 1.552 4.051 1.552 9.048v5.3c0 4.997 0 7.495-1.552 9.048-1.553 1.552-4.051 1.552-9.048 1.552h-5.3c-4.997 0-7.495 0-9.048-1.552C.75 24.145.75 21.647.75 16.65v-5.3z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandex);
export default __webpack_public_path__ + "static/media/yandex.81b12edea1f8c242a22df37b7e791074.svg";
export { ForwardRef as ReactComponent };